import Word from '@/components/Exercise/Word'

export default () => {
  return {
    components: {
      Word,
    },
    props: {
      word: {
        type: Object,
        required: true,
      },
    },
    computed: {
      bindProps () {
        return {
          ...this.$attrs,
        }
      },
    },
  }
}
